<template>
  <v-container fluid class="px-0">
    <v-card outlined class="mb-4" v-if="!loadDefault">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4"> {{ $t('Filtras') }}</v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <form @keydown.enter.prevent="submit()">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="4">
              <el-text-field
                label="Kodas"
                v-model="mainData['nar_code-search-like']"
                hide-details
                :maxlength="150"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-text-field
                label="NIRVAR srities pavadinimas"
                v-model="mainData['name-search-like']"
                hide-details
                :maxlength="20"
              />
            </v-col>
            <v-col cols="12" md="4" lg="4">
              <el-autocomplete
                :items="classifiers.action"
                itemvalue="value"
                itemtext="text"
                label="Paslauga/veiksmas"
                v-model="mainData['action-search-custom']"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <el-button
                class="mr-1"
                title="Ieškoti"
                :loading="loading"
                color="primary"
                icon="ieškoti"
                @click.native.stop="searchData()"
              />
              <el-button
                color="secondary"
                icon="išvalyti"
                title="Išvalyti"
                :loading="loading"
                @click.native="clearData()"
              />
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { classifiersGet } from '@/services/classifierService.js'

export default {
  name: 'NirvarLimitSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    loadDefault: null,
    mainData: {},
    classifiers: {},
    enableVeiksmas: false,
  }),
  created() {
    this.getSearchParams()
    this.getClassifiers()

  },
  computed: {
    ...mapGetters(['searchParams']),
  },
  inject: {
    $validator: '$validator',
  },
  methods: {
    getSearchParams() {
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    getClassifiers() {
      classifiersGet({ classifiers: ['action']})
        .then(res => this.classifiers = res.data.classifiers)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally(
        this.searchData()
        )
    },
    searchData() {
      let searchData = {
        ...this.mainData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.searchData()
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
